import {
  DTOCreateForgeIterationMessage,
  DTOCreateForgeIterationMessageResponse,
  DTODeleteForgeIterationMessageResponse,
  DTOUpdateForgeIterationMessage,
  DTOUpdateForgeIterationMessageResponse,
} from "../../dto";
import { RequestExecutor } from "../../transport";

export class ForgeIterationMessagesEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  list(workspaceId: string, projectId: string, iterationId: string) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/projects/${projectId}/iterations/${iterationId}/messages`,
      DTOUpdateForgeIterationMessageResponse,
      {
        method: "GET",
      }
    );
  }

  create(workspaceId: string, projectId: string, iterationId: string, body: DTOCreateForgeIterationMessage) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/projects/${projectId}/iterations/${iterationId}/messages`,
      DTOCreateForgeIterationMessageResponse,
      {
        method: "POST",
        body,
      }
    );
  }

  update(
    workspaceId: string,
    projectId: string,
    iterationId: string,
    id: string,
    body: DTOUpdateForgeIterationMessage
  ) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/projects/${projectId}/iterations/${iterationId}/messages/${id}`,
      DTOCreateForgeIterationMessageResponse,
      {
        method: "PUT",
        body,
      }
    );
  }

  delete(workspaceId: string, projectId: string, iterationId: string, id: string) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/projects/${projectId}/iterations/${iterationId}/messages/${id}`,
      DTODeleteForgeIterationMessageResponse,
      {
        method: "DELETE",
      }
    );
  }
}
